import { type Atom, useAtom } from 'jotai';
import { loadable } from 'jotai/utils';

export const useAsyncAtom = <T,>(atom: Atom<T>) => {
  const [value] = useAtom(loadable(atom));

  return {
    error: value.state === 'hasError' ? (value.error as Error) : undefined,
    loading: value.state === 'loading',
    value: value.state === 'hasData' ? value.data : undefined,
  };
};
